import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { SkinColor } from 'page/ProfileScreen/SkinColors/SkinColor'

export const SkinColors = observer(() => {
  return <Panel>
    <SkinColor skin={1} />
    <SkinColor skin={2} />
    <SkinColor skin={3} />
    <SkinColor skin={4} />
    <SkinColor skin={5} />
  </Panel>
})
